import { apiCaller } from '@/api/apiCaller';
import { apihost } from '@/api/urls';

const getAll = () => apiCaller.get('/flag/', apihost);

export const flagApi = {
    getAll,
};
